import { __assign, __read, __rest } from "tslib";
/* eslint-disable dot-notation */
import React, { useRef, useState } from "react";
import classNames from "classnames";
import { useDefaultValue } from "../form/controlled";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { useConfig } from "../_util/config-context";
import { noop } from "../_util/noop";
import { KeyMap } from "../_util/key-map";
export var TextArea = forwardRefWithStatics(function (props, ref) {
    var _a;
    var classPrefix = useConfig().classPrefix;
    var _b = useDefaultValue(props, ""), placeholder = _b.placeholder, disabled = _b.disabled, readonly = _b.readonly, size = _b.size, className = _b.className, style = _b.style, value = _b.value, onChange = _b.onChange, showCount = _b.showCount, _c = _b.onCompositionStart, onCompositionStart = _c === void 0 ? noop : _c, _d = _b.onCompositionEnd, onCompositionEnd = _d === void 0 ? noop : _d, _e = _b.onKeyPress, onKeyPress = _e === void 0 ? noop : _e, _f = _b.onPressEnter, onPressEnter = _f === void 0 ? noop : _f, restProps = __rest(_b, ["placeholder", "disabled", "readonly", "size", "className", "style", "value", "onChange", "showCount", "onCompositionStart", "onCompositionEnd", "onKeyPress", "onPressEnter"]);
    var composingRef = useRef(false);
    // 记录 `composition` 事件过程中值以实现受控
    var _g = __read(useState(""), 2), composingRefValue = _g[0], setComposingValue = _g[1];
    var inputClassName = classNames(classPrefix + "-textarea", (_a = {},
        _a[className] = className,
        _a["size-" + (size === "full" ? size + "-width" : size)] = size,
        _a));
    var hasRows = restProps.rows;
    var inputProps = __assign({ placeholder: placeholder, className: inputClassName, readOnly: readonly, disabled: disabled, 
        // 受样式限制 rows 属性没有生效
        style: hasRows ? __assign({ height: "auto" }, (style || {})) : style, value: composingRef.current ? composingRefValue : value, onChange: function (event) {
            if (composingRef.current) {
                setComposingValue(event.target.value);
            }
            else {
                onChange(event.target.value, { event: event });
            }
        }, onCompositionStart: function (event) {
            composingRef.current = true;
            onCompositionStart(event);
        }, onCompositionEnd: function (event) {
            if (composingRef.current) {
                composingRef.current = false;
                onChange(event.currentTarget.value, { event: event });
            }
            setComposingValue("");
            onCompositionEnd(event);
        }, onKeyPress: function (event) {
            if (event.key === KeyMap.Enter) {
                onPressEnter(event.currentTarget.value, event);
            }
            onKeyPress(event);
        } }, restProps);
    var component = React.createElement("textarea", __assign({ ref: ref }, inputProps));
    if (showCount) {
        var max = inputProps.maxLength;
        var len = value ? String(value).length : 0;
        return (React.createElement("div", { className: classPrefix + "-textarea-group", style: size === "full" ? { width: "100%" } : undefined },
            component,
            React.createElement("label", { className: classPrefix + "-textarea__label" }, max ? len + " / " + max : len)));
    }
    return component;
}, {
    /**
     * 在表单布局中，和 label 的默认对齐方式
     */
    defaultLabelAlign: "middle",
});
TextArea.displayName = "TextArea";
//# sourceMappingURL=TextArea.js.map